import { useSearchTarget } from '@/hooks/useSearchTarget';
import { PORTAL_OFFICE_TYPE, SEARCH_TARGET_VALUES } from '@/types/types';
import { useRouter, useSearchParams } from 'next/navigation';
import { useCallback, useTransition } from 'react';

type Props = {
  type: SEARCH_TARGET_VALUES;
  isPublicSearch: boolean;
};

export const useLogic = ({ type, isPublicSearch }: Props) => {
  const [isPending, startTransition] = useTransition();
  const isSearchHospital = type === 'hospital';

  const router = useRouter();
  const searchParams = useSearchParams();
  const { setSearchTarget } = useSearchTarget();

  const handleToggle = useCallback(
    () => {
      const params = new URLSearchParams(searchParams.toString());
      params.delete('page');

      const searchTarget: SEARCH_TARGET_VALUES = isSearchHospital
        ? 'station'
        : 'hospital';
      params.set('searchTarget', searchTarget);
      setSearchTarget(searchTarget);

      startTransition(() => {
        router.push(
          `/${
            isPublicSearch ? 'public' : 'app'
          }/stations/search?${params.toString()}`,
        );
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isPublicSearch, isSearchHospital, router, searchParams],
  );

  return {
    activeValue: isSearchHospital
      ? PORTAL_OFFICE_TYPE.HOSPITAL
      : PORTAL_OFFICE_TYPE.NURSING_STATION,
    handleToggle,
    isPending,
  };
};
